import { EnumModel } from "./EnumModel";

export class GroupedEnumModel {
  public id: any;
  public value: EnumModel[];

  constructor(id?: any, value?: EnumModel[]) {
    this.id = id;
    this.value = value;
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/objects/GroupedEnumModel.ts